/* 
Dependencies
*/
import LogDetails from "../../components/CallLogEntry/CallLogEntry";
import * as service from "../../Service/CallCenter.Service";
import { mapGetters } from "vuex";

export default {
  name: "CallCenter",

  components: { LogDetails },

  data: () => ({
    activeTab: 1,
    linkTab: 0,
    isEditPopup: false,
    Categories: [],
    CCLinks: [],
    callDetails: [],
    search: "",
    callDetailsHeader: [
      { text: "Customer", sortable: true, value: "Customer" },
      { text: "Number", sortable: false, value: "callnumber" },
      { text: "Category", sortable: true, value: "CategoryText" },
      { text: "Action", sortable: false, width: "7" }
    ],
    editCallDetails: {},
    summeryDetails: []
  }),

  async mounted() {
    await this.GetCategoriesAndCCLinks();
    await this.GetCallDetails();
    await this.GetAgentCallSummary();
    // console.log(this.getUserDetails);

    this.$router.app.$on("RefreshCallDetails", () => {
      this.GetCallDetails();
      this.GetAgentCallSummary();
      this.isEditPopup = false;
    });
  },

  computed: {
    getSummeryHeader() {
      let SummeryHeader = [
        { text: "Category", sortable: true, value: "CategoryText" },
        {
          text: this.getUserDetails.userName,
          sortable: true,
          align: "center",
          value: "Agent"
        },
        { text: "Total", sortable: true, align: "center", value: "Total" }
      ];
      return SummeryHeader;
    },
    ...mapGetters(["getUserDetails"])
  },

  methods: {
    async GetCategoriesAndCCLinks() {
      let result = await service.GetCategoriesAndCCLinks();
      if (!result.error) {
        this.Categories = result.data.categories;
        this.CCLinks = result.data.ccLinks;
      }
    },
    async GetCallDetails() {
      let email = this.getUserDetails.email;
      let result = await service.GetCallDetails(
        email,
        new Date().toDateString()
      );
      if (!result.error) {
        this.callDetails = result.data;
      }
    },
    EditCallDetails(call) {
      this.editCallDetails = {
        Ctrl: call.ctrl,
        Idate: new Date().toLocaleString().replace(",", ""),
        EmpNo: call.empno,
        Email: call.email,
        CustomerName: call.Customer,
        PhoneNumber: call.callnumber,
        CategoryId: call.Category,
        SubCategoryId: call.SubCategory,
        Remarks: call.Remarks
      };
      this.isEditPopup = true;
    },
    async GetAgentCallSummary() {
      let result = await service.GetAgentCallSummary(
        this.getUserDetails.email,
        new Date().toDateString()
      );
      if (result.error) {
        return;
      } else {
        this.summeryDetails = result.data;
      }
    }
  }
};
